import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MUser } from '@argalis-apps/models';
import { CommunicationConfigService } from '@argalis-apps/angular-global';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(private communicationConfigService: CommunicationConfigService, private http: HttpClient) {}

  getInfoDashboard(userConnected: MUser.CUser) {
    return this.http.post<[]>(
      `${this.communicationConfigService.getApiUri()}/session-dashboard-extranet/`,
      userConnected
    );
  }
}
